/*
  Custom Onboarding Slide placeholder which can be fulfilled and added to the onboarding
  using A/B testing tools like Dynamic Yield.
  To add the placeholder to the onboarding steps 'customPlaceholder{specificName}' string
  should be included in the steps list where {specificName} is the name of the slide.
  For example 'customPlaceholderAcq' string as a second element in the steps list array will add a
  second placeholder slide into onboarding where wrapper has a 'mn_customPlaceholderAcqStepWrap' className.
*/

import React from 'react';
import SlideCounter from '../SlideCounter/SlideCounter';

function CustomPlaceholder({ handlePlaceholderDoneClick, stepsData }) {
  return (
    <>
      <div className="mn_slide mn_slidePlacehodler" />
      <div className="mn_content">
        <SlideCounter stepsData={stepsData} />
        <div className="mn_bottomContent">
          <button
            className="mn_button mn_stepButton"
            onClick={handlePlaceholderDoneClick}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}

export default CustomPlaceholder;
